var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "ui-close-button",
      class: _vm.classes,
      attrs: { "aria-label": "Close", type: "button", disabled: _vm.disabled },
      on: { click: _vm.onClick },
    },
    [
      _c(
        "div",
        { staticClass: "ui-close-button__icon" },
        [
          _c("UiIcon", [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M18.984 6.422L13.406 12l5.578 5.578-1.406 1.406L12 13.406l-5.578 5.578-1.406-1.406L10.594 12 5.016 6.422l1.406-1.406L12 10.594l5.578-5.578z",
                  },
                }),
              ]
            ),
          ]),
        ],
        1
      ),
      _c("span", { staticClass: "ui-close-button__focus-ring" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }